import _get from 'lodash/get';

export const getAppliedDimension = (state, formulaId) => {
	return _get(state, `reportGroupFormulasById[${formulaId}].appliedDimension`, {});
};
